import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { matchPath, useHistory, useLocation } from 'react-router';

import { useExperiment } from '@xingternal/hub';

import { routes } from '@/config';
import { useBusinessCityQuery } from '@/graphql/generated';
import { LocationSuggestion, useLoginStates } from '@/hooks';

import { DEFAULT_RADIUS } from '../../../constants';
import { SearchBoxComponent } from '../search-box-component';

function getPropActionOrigin(pathname: string): string | null {
  if (matchPath(pathname, routes.companiesDirectory)) {
    return 'company_directory';
  }

  return null;
}

export const ExternalSearchBox: React.VFC = () => {
  const { isLoggedOut } = useLoginStates();
  const history = useHistory();
  const { pathname } = useLocation();
  const [keywords, setKeywords] = useState('');
  const [location, setLocation] = useState('');
  const [cityId, setCityId] = useState('');
  const [radius, setRadius] = useState(0);

  const { data } = useBusinessCityQuery({ skip: isLoggedOut });
  const businessCity = data?.viewer?.xingId?.location?.city;

  // ABACUS-421
  const isVisionTypeSearch = useExperiment('ABACUS-421') === 'B';

  useEffect(() => {
    if (businessCity) {
      setLocation(businessCity);
      setRadius(DEFAULT_RADIUS);
    }
  }, [businessCity]);

  const onSelectLocation = (item: LocationSuggestion): void => {
    setLocation(item.location);
    setCityId(item.cityId);
  };

  const onSubmit = (): void => {
    const propTrackActionOrigin = getPropActionOrigin(pathname);

    const query = {
      keywords: keywords || undefined,
      location: location || undefined,
      cityId: cityId || undefined,
      radius: location && radius ? radius : undefined,
      sc_o: 'jobs_search_button',
      ...(propTrackActionOrigin ? { sc_o_PropActionOrigin: getPropActionOrigin(pathname) } : {}),
    };

    if (isVisionTypeSearch) {
      const url = `${routes.visionTypeSearch}?${queryString.stringify(query)}`;
      window.location.assign(url);
    } else {
      const url = `${routes.search}?${queryString.stringify(query)}`;
      history.push(url);
    }
  };

  return (
    <SearchBoxComponent
      keywordsInput={keywords}
      locationInput={location}
      radiusInput={radius}
      onChangeKeywords={setKeywords}
      onSelectKeywords={setKeywords}
      onChangeLocation={setLocation}
      onSelectLocation={onSelectLocation}
      onSelectRadius={setRadius}
      onSubmit={onSubmit}
    />
  );
};
